<template>
  <CollapsibleCard :editable="false">
    <template v-slot:header> HÄNDELSER </template>

    <template v-slot:info> {{ logs.length }} händelser</template>

    <template v-slot:view>
      <ApplicationEventsView :logs="logs" />
    </template>

  </CollapsibleCard>
</template>

<script>
import {mapGetters} from 'vuex'
import API from '@/services/api.js'
import get from 'lodash/get'
import CollapsibleCard from '@/components/common/CollapsibleCard'
import ApplicationEventsView from './ApplicationEventsView.vue'

export default {
  name: 'ApplicationEvents',
  components: {
    CollapsibleCard,
    ApplicationEventsView
  },

  data: () => ({
    logs: [],
    runSem: false
  }),

  watch: {
    'selectedApplication.stateId': {
      handler(newValue, oldValue) {
        this.initStateLogs()
      }
    },
    'selectedApplication.id': {
      handler(newValue, oldValue) {
        this.initStateLogs()
      }
    },
    'selectedApplication.approvedBy': {
      handler(newValue, oldValue) {
        this.initStateLogs()
      },
      deep: true
    },
    'selectedApplication.orderedBy': {
      handler(newValue, oldValue) {
        this.initStateLogs()
      },
      deep: true
    }
  },

  created() {
    this.initStateLogs()
  },

  computed: {
    ...mapGetters('application', ['selectedApplication', 'isCompanyApplication']),
    ...mapGetters('currentuser', ['currentUser', 'currentUserRole'])
  },

  methods: {
    initStateLogs() {
      //- To keep it from running multiple times at once
      if (this.runSem) return
      this.runSem = true

      //- Grab some data
      API.getApplicationStateLogs(get(this, 'selectedApplication.id', 0))
        .then(res => {
          this.logs = res.data ?
            res.data.sort((a, b) => (a.createdAt < b.createdAt ? 1 : b.createdAt < a.createdAt ? -1 : 0)) :
            []
          this.runSem = false
        })
        .catch(e => {
          console.log(e)
          this.logs = []
          this.runSem = false
        })
    }
  }
}
</script>

<style lang="scss">
.hoverable-body:hover {
  background-color: rgba(53, 189, 214, 0.12);
}

.v-timeline-item.application {
  .v-timeline-item__divider {
    .v-timeline-item__dot {
      .v-timeline-item__inner-dot.primary {
        color: var(--v-primary-darken4) !important;
        background-color: var(--v-primary-darken4) !important;
      }
    }
  }
}
.v-timeline-item.order {
  .v-timeline-item__divider {
    .v-timeline-item__dot {
      .v-timeline-item__inner-dot.primary {
        color: rgba(0, 105, 15, 0.5) !important;
        background-color: rgba(0, 105, 15, 0.5) !important;
      }
    }
  }
}
.v-timeline-item.grundutbildning {
  .v-timeline-item__divider {
    .v-timeline-item__dot {
      .v-timeline-item__inner-dot.primary {
        color: rgba(136, 226, 0, 0.5) !important;
        background-color: rgba(136, 226, 0, 0.5) !important;
      }
    }
  }
}
.v-timeline-item.kvalificeringstid {
  .v-timeline-item__divider {
    .v-timeline-item__dot {
      .v-timeline-item__inner-dot.primary {
        color: rgba(255, 151, 0, 0.5) !important;
        background-color: rgba(255, 151, 0, 0.5) !important;
      }
    }
  }
}
.v-timeline-item.ebok {
  .v-timeline-item__divider {
    .v-timeline-item__dot {
      .v-timeline-item__inner-dot.primary {
        color: rgba(226, 0, 190, 0.5) !important;
        background-color: rgba(226, 0, 190, 0.5) !important;
      }
    }
  }
}

.upper {
  text-transform: uppercase !important;
}
</style>